// import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, ValidatorFn } from '@angular/forms';

// @Directive({
//   providers: [
//     { provide: NG_VALIDATORS, useExisting: ForbiddenDirective, multi: true },
//   ],
//   selector: '[appForbidden]',
// })
// export class ForbiddenDirective {
//   constructor() {}

  /** A user's Password can't match the given regular expression */
  export function forbiddenValidator(): ValidatorFn {
   return (control: AbstractControl): ValidationErrors | null => {
     const value = control.value;

     if (!value) {
       return null;
     }

     const hasUpperCase = /[A-Z]+/.test(value);

     const hasLowerCase = /[a-z]+/.test(value);

     const hasNumeric = /[0-9]+/.test(value);

     const hasSpecialChar = /[?#_%.@]+/.test(value);

     const passwordValid =
       hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar;

     return !passwordValid ? { passwordStrength: true } : null;
   };
  }
// }

